module.exports = __webpack_public_path__ + "static/logo-069450b50b94b3e1173002bbf6251f42.png";